import { render, staticRenderFns } from "./remind.pug?vue&type=template&id=e12a8710&lang=pug&"
import script from "./remind.ts?vue&type=script&lang=ts&"
export * from "./remind.ts?vue&type=script&lang=ts&"
import style0 from "./remind.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports